<template>
  <div class="div-dropdown-component">
    <SingleSelectInteger
      :value.sync="compValue"
      :value-property="'value'"
      :options="optionsCostsCenters"
      :readonly="readonly"
    />
    <span v-if="problemToList" class="text-danger">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CostCenterDropdown",
  props: {
    costCenterId: Number,
    costsCenters: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SingleSelectInteger: () => import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  data() {
    return {
      errorMessage: null,
      optionsCostsCenters: [
        { value: null, text: "Carregando centros de custo" },
      ],
    };
  },
  created() {
    if (this.costsCenters && this.costsCenters != null) {
      this.optionsCostsCenters = this.costsCenters;
    } else {
      this.loadCostsCenters();
    }
  },
  computed: {
    compValue: {
      get: function () {
        return this.costCenterId;
      },
      set: function (newValue) {
        this.$emit("update:costCenterId", parseInt(newValue));
      },
    },
    problemToList() {
      return this.errorMessage && this.errorMessage != "";
    },
  },
  methods: {
    loadCostsCenters() {
      this.$apiScheduler
        .get("/costCenter/list")
        .then((response) => {
          this.optionsCostsCenters = response.data.map((item) => ({
            value: item.id,
            text: item.code + " - " + item.name,
          }));
        })
        .catch((error) => {
          this.optionsCostsCenters = [
            { value: null, text: "Erro ao carregar centros de custo" },
          ];
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.errorMessage = error.message;
          }
        });
    },
  },
};
</script>